var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("coda-upload-title")) + " "),
          _vm.uploading
            ? _c("w-progress-linear", {
                staticClass: "full inTitle",
                attrs: { color: "#1c86f0" },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-bank-type", {
                    attrs: { fancy: "", "use-ids": "", "coda-import-only": "" },
                    model: {
                      value: _vm.bankId,
                      callback: function ($$v) {
                        _vm.bankId = $$v
                      },
                      expression: "bankId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  !_vm.file
                    ? _c("app-file-upload", {
                        attrs: {
                          sending: _vm.uploading,
                          label: _vm.$ct("coda-upload-label"),
                          multiple: true,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.append($event)
                          },
                          finished: function ($event) {
                            return _vm.upload()
                          },
                          start: function ($event) {
                            _vm.files = []
                          },
                        },
                      })
                    : _c(
                        "w-row",
                        { attrs: { center: "" } },
                        [
                          _vm._v(" " + _vm._s(_vm.file.name) + " "),
                          _c(
                            "w-button",
                            {
                              attrs: { flat: "" },
                              on: {
                                click: function ($event) {
                                  _vm.file = null
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "times" } })],
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { disabled: _vm.uploading, icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: {
                disabled: _vm.file == null || _vm.uploading,
                icon: "check",
              },
              on: {
                click: function ($event) {
                  return _vm.upload()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }